import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  MyAddressAllResponse,
  MyVehicleAllResponse,
} from '../../../../../core/models/user.model';
import { AddressInfoPayload } from '../../../../../core/models/card.model';
import {
  CardActivate,
  CardActiveGeneratePayload,
  CityParkingCardAdvanceApproveRespond,
} from '../../../../../core/models/coupon.model';
import {
  FeeType,
  MasterFee,
  Providers,
} from '../../../../../core/models/information.model';
import { ApiService } from '../../../../../core/services/api.service';
import { ToastNotifService } from '../../../../../core/services/toast-notif.service';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import { InputComponent } from '../../../../../tools/forms/input/input.component';
import { ToastService } from 'angular-toastify';
import { ApiFormService } from '../../../../../core/services/api-form.service';
import { ModalAdminActivityHistoryComponent } from '../../../modals/system-settings/modal-admin-activity-history/modal-admin-activity-history.component';
import { AdminActivityEntityTypes } from '../../../../../core/models/system-settings/admin-activity-log.model';

@Component({
  selector: 'app-coupon-parking-list-details',
  imports: [CommonModule, FormsModule, InputComponent, ModalAdminActivityHistoryComponent],
  templateUrl: './coupon-parking-list-details.component.html',
  styleUrl: './coupon-parking-list-details.component.css',
})
export class CouponParkingListDetailsComponent {
  readonly activityEntityTypes = AdminActivityEntityTypes;
  showActivityHistory = false;

  // URL
  urlCardAdvanceApproveId: string | null = null;

  // CityCardAdvanceApproveDetails
  cardAdvanceApproveDetailsModel: CardActivate[] = [];
  cardAdvanceApproveDetailsCreateModel: CardActivate = {
    id: 0,
    name: '',
    code: '',
    phone: '',
    plateNumber: '',
    status: false,
    startDate: null,
    endDate: null,
    activateDate: null,
  };

  optionTypeCreateMember: { id: number; name: string }[] = [
    { id: 1, name: 'เบอร์โทร' },
    { id: 2, name: 'ทะเบียน' },
  ];

  // ( Copy )
  copied = false; // ใช้โชว์สถานะ

  // CityParkingCardAdvanceApprovePayload
  cardAdvanceApprovePayloadModel: CityParkingCardAdvanceApproveRespond = {
    id: 0,
    name: '',
    cardTypeName: '',
    startDate: null,
    endDate: null,
    qty: 0,
    status: 0,
    siteId: 0,
    vehicleTypeName: '',
    siteName: '',
    remark: '',
    fullName: '',
    cardActivateetails: [],
  };

  optionCardTypeID = [
    { id: 1, name: 'รถยนต์' },
    { id: 2, name: 'รถจักรยานยนต์' },
  ];
  optionAccountBank: { value: number; label: string }[] = [];
  optionFeeTypeID: { value: number; label: string; status: boolean }[] = [];
  optionFeeID: MasterFee[] = [];

  base64Change: string = '';
  user_id: number = 0;
  // ( File )
  fileName: string | null = null;
  base64: string = '';

  // (Site ID)
  searchProvider: string = '';
  allProviders: Providers[] = [];
  siteId: number | null = null;
  siteName: string = '';
  CardOptions: {
    value: number;
    label: string;
    fig_day: number;
    vehicle_type_name: string;
    subscription_id: number;
  }[] = [];
  carFilteredPlateList: MyVehicleAllResponse[] = [];
  selectCarPlate: MyVehicleAllResponse[] = [];
  selectedCar: string | null = null;

  isRequestTax: boolean = false;
  isCheckboxFee: boolean = false;
  isShowBank: boolean = false;

  // (Select)
  isOpenSelectVehicleTypeId: boolean = false;
  selectVehicleTypeId: { id: number; name: string } = { id: 0, name: '' };
  isOpenSelectSiteId: boolean = false;
  isOpenSelectFeeTypeId: boolean = false;

  // Loading
  isLoading: boolean = false;

  // Modal
  showTaxModal: boolean = false;
  showCreateModal: boolean = false;
  showSelectProviderModal: boolean = false;

  // Disable
  isDisableInput: boolean = false;
  isDisableRemark: boolean = false;

  // Validate
  isTextValid: { where: string; result: boolean } = { where: '', result: true };
  isNumberValid: { where: string; result: boolean } = {
    where: '',
    result: true,
  };
  isSpecialValid: { where: string; result: boolean } = {
    where: '',
    result: true,
  };
  isTextNumberValid: { where: string; result: boolean } = {
    where: '',
    result: true,
  };

  constructor(
    private apiService: ApiService,
    private apiFormService: ApiFormService,
    private toast: ToastService,
    private http: HttpClient,
    private cookieService: CookieService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.getProviders();
    this.user_id = parseInt(this.cookieService.get('user_id'));
    // อ่าน param id จาก route
    this.route.paramMap.subscribe((params) => {
      this.urlCardAdvanceApproveId = params.get('id');
      //console.log('Current Url ID:', this.urlCardAdvanceApproveId);

      if (this.urlCardAdvanceApproveId) {
        this.isDisableInput = true;

        this.getCardAdvancesApproveById(this.urlCardAdvanceApproveId);
      }
    });
  }

  /* ------------------------------------------------- Function ------------------------------------------------ */

  /* ---- Modal ----*/
  closeCreateModal() {
    this.showCreateModal = false;
  }

  /* ---- Select ----*/
  onClickSelectVehicleTypeId(selectOption: { id: number; name: string }) {
    this.isOpenSelectVehicleTypeId = !this.isOpenSelectVehicleTypeId;
    this.selectVehicleTypeId = selectOption;

    // console.log(
    // 'selectVehicleTypeId : ',
    //   this.selectVehicleTypeId,
    //   selectOption
    // );
  }

  /* --- CardAdvancesApprove --- */
  onSetValueCardAdvanceApproveResponse(
    response: CityParkingCardAdvanceApproveRespond
  ) {
    this.cardAdvanceApprovePayloadModel.id = response.id;
    this.cardAdvanceApprovePayloadModel.name = response.name;
    this.cardAdvanceApprovePayloadModel.startDate = response.startDate
      ? response.startDate
      : null;
    this.cardAdvanceApprovePayloadModel.endDate = response.endDate
      ? response.endDate
      : null;
    this.cardAdvanceApprovePayloadModel.qty = response.qty;
    this.cardAdvanceApprovePayloadModel.status = response.status;
    this.cardAdvanceApprovePayloadModel.siteId = response.siteId;
    this.cardAdvanceApprovePayloadModel.siteName = response.siteName;
    this.siteName = response.siteName;
    this.cardAdvanceApprovePayloadModel.vehicleTypeName =
      response.vehicleTypeName;
    this.cardAdvanceApprovePayloadModel.cardTypeName = response.cardTypeName;
    this.cardAdvanceApprovePayloadModel.remark = response.remark;
    this.cardAdvanceApprovePayloadModel.cardActivateetails =
      response.cardActivateetails;
    this.cardAdvanceApproveDetailsModel = response.cardActivateetails;

    //console.log(
    // 'this.cardAdvanceApprovePayloadModel',
    //   this.cardAdvanceApprovePayloadModel
    // );
  }
  onClickCreateCodeMember() {
    this.onValidateCardAdvanceApprove();
    const payload: CardActiveGeneratePayload = {
      uid: this.user_id,
      cardAdvance: this.cardAdvanceApprovePayloadModel.id,
      remark: this.cardAdvanceApprovePayloadModel.remark,
    };
    if (payload) {
      //console.log('payload', payload);
      this.sentGenerateCardAdvanceApproveCode(payload);
    }
  }
  onValidateCardAdvanceApprove() {
    // if (this.cardAdvanceApprovePayloadModel.remark == '') {
    //   this.toast.error('กรุณากรอกรายละเอียด');
    //   return;
    // }
  }

  /* --- Card Activate --- */
  // ( Export excel )
  onExportToExcel() {
    const headersCardAdvanceDetailsModel = [
      'id',
      'name',
      'code',
      'phone',
      'plateNumber',
      'startDate',
      'endDate',
      'remark',
    ];

    // รวม headers + sample data
    const worksheet = XLSX.utils.json_to_sheet(
      this.cardAdvanceApproveDetailsModel,
      { header: headersCardAdvanceDetailsModel }
    );
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Template');

    XLSX.writeFile(workbook, 'CardAdvanceDetail_Template.xlsx');
  }
  onClickDeleteCardAdvanceApproveDetails(index: number) {
    this.cardAdvanceApproveDetailsModel.splice(index, 1);
    //this.toast.success('ลบข้อมูลเรียบร้อย');
  }
  // ( Copy )
  onClickCopyCode(code: string) {
    navigator.clipboard.writeText(code).then(() => {
      this.toast.success('คัดลอกเรียบร้อย');
      return;
    });
  }

  /* ---- Validate ----*/
  onChangeValidateText(where: string, value: string) {
    const check = value.match(/[^a-zA-Zก-๙\s]/g);
    if (value == '' || check) {
      this.isTextValid = { where: where, result: false };
    } else {
      this.isTextValid = { where: where, result: true };
    }
    ////console.log("check text : " , value , check );
  }
  onChangeValidateNumber(where: string, value: string) {
    const check = value.match(/[^0-9]/g);
    if (value == '' || check) {
      this.isNumberValid = { where: where, result: false };
    } else {
      this.isNumberValid = { where: where, result: true };
    }
    //console.log('check number : ', value, check);
  }
  onChangeValidateTextNumber(where: string, value: string) {
    const check = value.match(/[^a-zA-Z0-9ก-๙\s]/g);
    if (value == '' || check) {
      this.isTextNumberValid = { where: where, result: false };
    } else {
      this.isTextNumberValid = { where: where, result: true };
    }
  }
  onChangeValidateSpecialChar(where: string, value: string) {
    const check = value.match(/[^a-zA-Z0-9ก-๙\s]/g);
    if (value == '' || check) {
      this.isSpecialValid = { where: where, result: false };
    } else {
      this.isSpecialValid = { where: where, result: true };
    }
    ////console.log("check text : " , value , check );
  }
  /* --------------------------------------------------- API ------------------------------------------------ */
  getProviders() {
    this.apiFormService.getProviders().subscribe({
      next: (res) => {
        Swal.close();
        // //console.log('res : ', res);
        this.allProviders = res;
      },
      error: (err) => {
        console.error('โหลดบัตรสมาชิกล้มเหลว', err);
        Swal.close();
      },
    });
  }
  /* --- CardAdvanceApprove --- */
  getCardAdvancesApproveById(card_advance_id: string) {
    this.apiService.getCardAdvancesApproveById(card_advance_id).subscribe({
      next: (response: CityParkingCardAdvanceApproveRespond) => {
        //console.log('getCardAdvancesApproveById : ', response);
        // Set Value
        this.onSetValueCardAdvanceApproveResponse(response);
      },
      error: (error) => {
        console.error('API error:', error);
      },
    });
  }
  sentGenerateCardAdvanceApproveCode(body: CardActiveGeneratePayload) {
    this.apiService.sentGenerateCardAdvanceApproveCode(body).subscribe({
      next: (response: any) => {
        //console.log('sentGenerateCardAdvanceApproveCode : ', response);
        if (response.code == '000') {
          this.isDisableRemark = true;
          // Set value
          if (this.urlCardAdvanceApproveId !== null) {
            this.getCardAdvancesApproveById(this.urlCardAdvanceApproveId);
          }
          this.toast.success(response.message);
        } else {
          this.toast.error(response.message);
        }
      },
      error: (error) => {
        console.error('API error:', error);
        this.isLoading = false;
        this.toast.error(error.message);
      },
    });
  }

  get couponEntityId(): number {
    return this.cardAdvanceApprovePayloadModel.id || Number(this.urlCardAdvanceApproveId) || 0;
  }

  get canShowActivityHistory(): boolean {
    return this.couponEntityId > 0;
  }

  openActivityHistory(): void {
    if (!this.canShowActivityHistory) return;
    this.showActivityHistory = true;
  }

  closeActivityHistory(): void {
    this.showActivityHistory = false;
  }
}
